import LiveKitTelemedicineFinished from './LiveKitTelemedicineFinished';

import TelemedicineContext from '../../context/telemedicine';

import { useCallback, useContext, useState } from 'react';

const LiveKitTelemedicineFinishedContainer = () => {
	const { telemedicine } = useContext(TelemedicineContext);

	const [rating, setRating] = useState(0);
	const [feedbackText, setFeedbackText] = useState('');
	const [submitted, setSubmitted] = useState(false);

	const onFeedbackTextChange = useCallback(event => setFeedbackText(event.target.value), []);

	// No feedback endpoint exists yet — this only reflects the submission locally so the
	// interaction is complete on screen; wire a real call here once one is available.
	const onSubmitFeedback = useCallback(() => setSubmitted(true), []);

	const onCloseSubmitted = useCallback(() => setSubmitted(false), []);

	return (
		<LiveKitTelemedicineFinished
			date={telemedicine.attendance?.start_date ? telemedicine.attendance.start_date : telemedicine.created_at}
			feedbackText={feedbackText}
			rating={rating}
			submitted={submitted}
			user={telemedicine.user}
			onCloseSubmitted={onCloseSubmitted}
			onFeedbackTextChange={onFeedbackTextChange}
			onSelectRating={setRating}
			onSubmitFeedback={onSubmitFeedback}
		/>
	);
};

export default LiveKitTelemedicineFinishedContainer;
